import { useSyncExternalStore } from "react";
import { getCookieConsent, subscribeCookieConsent } from "../util/privacyConsent";

export default function useCookieConsent() {
  return useSyncExternalStore(subscribeCookieConsent, getCookieConsent, () => null);
}
